const Load = () => <div className="load"></div>
export default Load;